import { useTranslation } from "react-i18next";

const Metropolia = () => {
  const { t } = useTranslation();
  return (
        <div className="metropolia">
            <div className="education-header">
                <img src="./images/metropolia.jpg" alt="Metropolia" className="education-image" />
                <div className="wrapper">
                    <h2>{t("metropolia")}</h2>
                    <p>{t("degree")}</p>
                    <p>{t("graduation")}</p>
                </div>
            </div>
        </div>
  );
};

export default Metropolia;
